import { I18nService } from '../../i18n/I18nService';
import { I18N_KEYS } from '../../i18n/keys';
import { FocusTrap } from '../../accessibility/FocusTrap';

export class ConfirmModal {
  private i18n: I18nService;
  private focusTrap: FocusTrap;
  private dialog: HTMLDialogElement | null = null;

  onConfirm: (() => void) | null = null;
  onCancel: (() => void) | null = null;

  constructor(i18n: I18nService, focusTrap: FocusTrap) {
    this.i18n = i18n;
    this.focusTrap = focusTrap;
  }

  render(): void {
    this.dialog = document.getElementById('confirm-modal') as HTMLDialogElement;
    if (!this.dialog) {
      this.dialog = document.createElement('dialog');
      this.dialog.id = 'confirm-modal';
      this.dialog.className = 'modal modal--confirm';
      document.body.appendChild(this.dialog);
    }
  }

  open(calledCount: number, elapsed: string): void {
    if (!this.dialog) this.render();

    this.dialog!.innerHTML = `
      <div class="modal__content">
        <h2>${this.i18n.t(I18N_KEYS.RESET_TITLE)}</h2>
        <p>${this.i18n.t(I18N_KEYS.RESET_MESSAGE)}</p>
        <ul>
          <li>${this.i18n.t(I18N_KEYS.COMPLETE_NUMBERS_CALLED, { count: calledCount })}</li>
          <li>${this.i18n.t(I18N_KEYS.COMPLETE_TIME_ELAPSED, { time: elapsed })}</li>
        </ul>
        <div class="modal__footer">
          <button id="confirm-cancel-btn" class="btn btn--secondary" type="button">${this.i18n.t(I18N_KEYS.SETTINGS_CANCEL)}</button>
          <button id="confirm-reset-btn" class="btn btn--danger" type="button">${this.i18n.t(I18N_KEYS.RESET_CONFIRM)}</button>
        </div>
      </div>
    `;

    this.dialog!.querySelector('#confirm-cancel-btn')?.addEventListener('click', () => this.close());
    this.dialog!.querySelector('#confirm-reset-btn')?.addEventListener('click', () => {
      this.close();
      if (this.onConfirm) this.onConfirm();
    });

    this.dialog!.showModal();
    this.focusTrap.activate(this.dialog!);
  }

  close(): void {
    this.focusTrap.deactivate();
    if (this.dialog?.open) {
      this.dialog.close();
    }
    if (this.onCancel) this.onCancel();
  }

  isOpen(): boolean {
    return this.dialog?.open === true;
  }
}
